'use strict';

var LegWizardDirective = function LegWizardDirective($timeout) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/leg-wizard.html'),
    controller: 'LegWizardController',
    link: function link(scope, elem, attr) {
      scope.manageMode = attr.manageMode;
      $timeout(scope.initWizard, 0);
    }
  };
};
LegWizardDirective.$inject = ['$timeout'];
module.exports = LegWizardDirective;